import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="m18.606 5.46.918.919c.307.307.476.715.476 1.149 0 .434-.169.842-.476 1.148L18.4 9.802l-3.216-3.216 1.125-1.126c.614-.613 1.684-.614 2.298 0ZM6.01 15.758l8.253-8.254 3.217 3.217-8.254 8.253a.324.324 0 0 1-.151.085l-3.672.915a.325.325 0 0 1-.393-.393l.914-3.672a.33.33 0 0 1 .086-.151Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEdit;
